// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetComparisonDesktopRequest,
  TGetComparisonDesktopModel,
  IMappers,
  TGetComparisonDesktopResponse,
  IGetComparisonDesktopResponse,
  IGetComparisonDesktopResponseError,
} from './types';

export const defaultConfig: TGetComparisonDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'offers-comparison',
  pathApi: '/v2/get-comparison-desktop/',
  responseType: 'json',
} as TGetComparisonDesktopModel;

export function createGetComparisonDesktopModel(parameters: IGetComparisonDesktopRequest): TGetComparisonDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetComparisonDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetComparisonDesktopRequest;
}

export async function fetchGetComparisonDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetComparisonDesktopOptions<TResponse200, TResponse400>): Promise<
  TGetComparisonDesktopResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetComparisonDesktopModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetComparisonDesktopResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetComparisonDesktopResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetComparisonDesktopResponse;
}
